import { TableHeaderConfig } from '../../components/_EOS/Table'

// Configuration for the headers of the ReturnsTable
export const positionAlertHeaderConfig: TableHeaderConfig[] = [
  {
    field: 'warehouseName',
    title: 'Almacén',
    sortable: true,
    formater: (warehouseName: string) =>
      !warehouseName ? 'Posición no posee almacén' : warehouseName
  },
  { field: 'zoneName', title: 'Zona', sortable: true },
  { field: 'typePositionName', title: 'Tipo de posición', sortable: true },
  { field: 'positionName', title: 'Posición', sortable: true }
]

export const initialStateFilters = {
  zoneId: undefined,
  warehouseId: undefined,
  positionName: undefined,
  sku: '',
  typeAlertId: 0,
  flowId: 0,
  action: 0,
  createdAt: '2024-01-01'
}
